module.exports = __webpack_public_path__ + "img/benefits01-02.7344f7f.webp";